export const DataPage = () => {
  return <div className="relative flex h-[700px] gap-4" />;
};
